import * as Search from "./Search";

const searchQuery = (w: typeof window): string =>
  Search.maybeQuery(Search.maybeFromWindow(w)) || "";

export default searchQuery;
